/* eslint-disable no-underscore-dangle */ function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';
import ReactCodeInput from 'react-verification-code-input';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Box, FormControl, FormHelperText, FormLabel, Grid, Typography, useTheme } from '@mui/material';
import { LinkButton } from '@procom-labs/atoms';
import { errorToString, useCounter } from '@procom-labs/common';
import { useAlert } from '../../hooks';
export var OtpInput = function(param) {
    var name = param.name, label = param.label, sendCode = param.sendCode, verifyCode = param.verifyCode, showValidationIcon = param.showValidationIcon, _param_fields = param.fields, fields = _param_fields === void 0 ? 6 : _param_fields, sx = param.sx, width = param.width, sendCodeOnInitialLoad = param.sendCodeOnInitialLoad;
    var theme = useTheme();
    var addAlert = useAlert().addAlert;
    var t = useTranslation('main').t;
    var _useField = _sliced_to_array(useField(name), 3), field = _useField[0], meta = _useField[1], helpers = _useField[2];
    var _useCounter = useCounter(), initCounter = _useCounter.initCounter, counter = _useCounter.counter;
    var _useState = _sliced_to_array(useState(false), 2), isVerifying = _useState[0], setIsVerifying = _useState[1];
    var codeRef = useRef(null);
    var subscriptionRef = useRef();
    var values = useMemo(function() {
        return field.value ? field.value.split('') : [];
    }, [
        field.value
    ]);
    var handleChange = useCallback(function() {
        if (meta.error) {
            helpers.setError('');
        }
    }, [
        helpers,
        meta.error
    ]);
    var clearSubscription = useCallback(function() {
        if (subscriptionRef.current && !subscriptionRef.current.closed) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
    }, []);
    var handleSendCode = useCallback(function() {
        if (sendCode) {
            var _codeRef_current;
            setIsVerifying(true);
            handleChange();
            clearSubscription();
            (_codeRef_current = codeRef.current) === null || _codeRef_current === void 0 ? void 0 : _codeRef_current.__clearvalues__();
            subscriptionRef.current = sendCode().subscribe({
                complete: function() {
                    initCounter({});
                },
                error: function(err) {
                    var errorDesc = typeof err === 'string' ? errorToString(err) : err.message;
                    addAlert({
                        severity: 'error',
                        message: errorDesc || 'Request failed'
                    });
                }
            });
            subscriptionRef.current.add(function() {
                return setIsVerifying(false);
            });
        }
    }, [
        addAlert,
        clearSubscription,
        handleChange,
        initCounter,
        sendCode
    ]);
    var handleVerifyCode = useCallback(function(code) {
        var _subscriptionRef_current;
        if (!meta.touched) {
            helpers.setTouched(true);
        }
        setIsVerifying(true);
        clearSubscription();
        subscriptionRef.current = verifyCode(code).subscribe({
            next: function(param) {
                var isCodeValid = param.isCodeValid, hasCodeExpired = param.hasCodeExpired, hasReachedMaxAttempts = param.hasReachedMaxAttempts;
                if (isCodeValid) {
                    helpers.setValue(code);
                } else {
                    var _codeRef_current;
                    if (hasCodeExpired) {
                        handleSendCode();
                        helpers.setError(t('common.inputs.otp.codeExpired'));
                    } else if (hasReachedMaxAttempts) {
                        helpers.setError(t('common.inputs.otp.maxAttempts'));
                    } else {
                        helpers.setError(t('common.inputs.otp.invalidCode'));
                    }
                    (_codeRef_current = codeRef.current) === null || _codeRef_current === void 0 ? void 0 : _codeRef_current.__clearvalues__();
                }
            },
            error: function(err) {
                var _codeRef_current;
                var errorDesc = typeof err === 'string' ? errorToString(err) : err.message;
                addAlert({
                    severity: 'error',
                    message: errorDesc || 'Request failed'
                });
                helpers.setTouched(false);
                (_codeRef_current = codeRef.current) === null || _codeRef_current === void 0 ? void 0 : _codeRef_current.__clearvalues__();
            }
        });
        (_subscriptionRef_current = subscriptionRef.current) === null || _subscriptionRef_current === void 0 ? void 0 : _subscriptionRef_current.add(function() {
            return setIsVerifying(false);
        });
    }, [
        addAlert,
        clearSubscription,
        handleSendCode,
        helpers,
        meta.touched,
        t,
        verifyCode
    ]);
    useEffect(function() {
        if (sendCode && sendCodeOnInitialLoad) {
            handleSendCode();
        }
        return clearSubscription;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function() {
        return function() {
            if (subscriptionRef.current && !subscriptionRef.current.closed) {
                subscriptionRef.current.unsubscribe();
                subscriptionRef.current = null;
            }
        };
    }, []);
    return /*#__PURE__*/ _jsxs(Box, {
        sx: _object_spread({}, sx),
        children: [
            /*#__PURE__*/ _jsxs(FormControl, {
                fullWidth: true,
                error: !!(!isVerifying && meta.touched && meta.error),
                sx: {
                    '.code-input-ctn': {
                        width: width !== null && width !== void 0 ? width : '100% !important',
                        div: {
                            display: 'flex',
                            columnGap: 1,
                            input: {
                                flexBasis: 0,
                                flexGrow: 1,
                                borderRadius: '4px',
                                fontFamily: 'inherit',
                                width: '100% !important',
                                caretColor: 'currentColor',
                                border: "solid 3px ".concat(theme.palette.primary.light),
                                '&:focus': {
                                    border: "solid 3px ".concat(theme.palette.primary.main)
                                },
                                '&:focus + input': {
                                    borderLeft: "solid 3px ".concat(theme.palette.primary.light)
                                }
                            }
                        },
                        'div[class*="styles_loading"]': {
                            height: '54px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }
                    }
                },
                children: [
                    label ? /*#__PURE__*/ _jsx(FormLabel, {
                        sx: {
                            marginBottom: 2
                        },
                        children: label
                    }) : null,
                    /*#__PURE__*/ _jsx(ReactCodeInput, {
                        autoFocus: true,
                        className: "code-input-ctn",
                        ref: codeRef,
                        values: values,
                        loading: isVerifying,
                        onChange: handleChange,
                        onComplete: handleVerifyCode,
                        fields: fields
                    }),
                    showValidationIcon && /*#__PURE__*/ _jsxs(Grid, {
                        mt: 2,
                        container: true,
                        flexWrap: "nowrap",
                        columnGap: 1,
                        alignItems: "center",
                        children: [
                            field.value ? /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                color: "success"
                            }) : /*#__PURE__*/ _jsx(CheckCircleOutlineIcon, {}),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "caption",
                                children: t('common.inputs.otp.validation')
                            })
                        ]
                    }),
                    !isVerifying && meta.touched && meta.error && /*#__PURE__*/ _jsx(FormHelperText, {
                        children: meta.error
                    })
                ]
            }),
            !field.value && sendCode && /*#__PURE__*/ _jsxs(Grid, {
                item: true,
                container: true,
                xs: 12,
                mt: 3.2,
                mb: 2.2,
                columnGap: 1,
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        color: "text.secondary",
                        children: t('common.inputs.otp.noCode')
                    }),
                    /*#__PURE__*/ _jsx(LinkButton, {
                        disabled: isVerifying || counter > 0,
                        underline: false,
                        onClick: handleSendCode,
                        sx: {
                            display: 'flex',
                            alignItems: 'center'
                        },
                        children: /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                t('common.inputs.otp.resendBtn'),
                                counter > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                    children: [
                                        t('common.inputs.otp.resendIn'),
                                        " ",
                                        counter
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
